import React from "react";
import { InfoRendService } from "../../services";
import {
  Alerta,
  TipoAlerta,
  Row,
  Col,
  Box,
  Form,
  Botao,
  Combo,
  CampoEstatico,
  TipoCampoEstatico,
} from "@intechprev/componentes-web";
import { MasterPage } from "..";
import { HeaderInfoRendEntidade } from "../../entidades";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

interface Props { }

interface State {
  datas: Array<HeaderInfoRendEntidade>;
  informe: HeaderInfoRendEntidade;
  referencia: number;
  erro: "";
}

export class InformeRendimentos extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("informe_rendimentos");

  private page = React.createRef<MasterPage>();
  private form = React.createRef<Form>();

  constructor(props: Props) {
    super(props);

    this.state = {
      datas: [],
      informe: null,
      referencia: 0,
      erro: ""
    };

    this.page = React.createRef();
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      var datas = await InfoRendService.BuscarInformes();
      if (datas.length > 0) {
        await this.setState({
          datas,
          referencia: datas[0].OID_HEADER_INFO_REND,
        });

        await this.carregarReferencia();
      }
    } catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ erro: Error });
    }
    finally {
      await this.page.current.alternarLoading();
    }
  };

  carregarReferencia = async () => {
    try {
      var informe = await InfoRendService.BuscarPorOid(
        this.state.referencia
      );
      await this.setState({
        informe,
      });
    } catch (err) {
      console.error(err);
    }
  };

  gerarRelatorio = async () => {
    await this.page.current.alternarLoading();

    try {
      const relatorio = await InfoRendService.Relatorio(
        this.state.referencia,
        false
      );

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(
          new Blob([relatorio]),
          "Informe de Rendimentos.pdf"
        );
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "informe de rendimentos.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ erro: (typeof Error === "object" ? await Error.text() : Error) });
    }
    finally {
      await this.page.current.alternarLoading();
    }
  };

  renderItens = (informe: any) => {
    const tempInformes = informe.Itens.map((linha: any, index: number) => {
      return (
        <tr key={index}>
          <td>{linha.DES_INFO_REND}</td>
          <td className="text-right" style={{ width: 150 }}>
            {linha.VAL_LINHA !== 0 && (
              <b>
                <CampoEstatico
                  valor={linha.VAL_LINHA}
                  tipo={linha.COD_LINHA === "608" ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro}
                />
              </b>
            )}
          </td>
        </tr>
      );
    });

    return tempInformes;
  };

  renderGrupos = () => {
    const tempGrupos = this.state.informe.Grupos.map((informe: any, index: number) => {
      return (
        <div key={index}>
          <h5>
            <b>{informe.DES_GRUPO}</b>
          </h5>
          <table className={"table table-striped"}>
            <tbody>{this.renderItens(informe)}</tbody>
          </table>
          <br />
        </div>
      );
    });
    return tempGrupos;
  };

  renderDados = () => {
    return (
      <Row>
        <Col className="col-lg-8">
          <Box titulo={"Resumo"}>
            <Form ref={this.form}>
              <Row className={"form-group"}>
                <Col className={"col-sm-6"}>
                  <Combo
                    contexto={this}
                    titulo={"Calendário:"}
                    tamanhoTitulo={"6"}
                    nome={"referencia"}
                    valor={this.state.referencia}
                    opcoes={this.state.datas}
                    padrao={this.state.referencia}
                    onChange={this.carregarReferencia}
                    nomeMembro={"ANO_CALENDARIO"}
                    valorMembro={"OID_HEADER_INFO_REND"}
                  />
                </Col>
              </Row>
            </Form>

            {this.state.informe && (
              <>
                <h4>
                  Ano Exercício:{" "}
                  <span className={"text-primary"}>
                    {this.state.informe.ANO_EXERCICIO}
                  </span>
                </h4>
                <h4>
                  Ano Calendário:{" "}
                  <span className={"text-primary"}>
                    {this.state.informe.ANO_CALENDARIO}
                  </span>
                </h4>
                <br />

                {this.renderGrupos()}

                <Botao
                  className={"btn btn-primary"}
                  titulo={"Gerar Informe de Rendimentos"}
                  onClick={this.gerarRelatorio}
                />
              </>
            )}
          </Box>
        </Col>
      </Row>
    );
  };

  renderVazio = () => {
    return (
      <Alerta
        tipo={TipoAlerta.danger}
        mensagem={"Nenhum informe disponível."}
      />
    );
  };

  render() {
    return (
      <MasterPage
        Funcionalidade={
          NumFuncionalidade.INFORME_DE_RENDIMENTOS_ASSISTIDOS_PENSIONISTAS
        }
        {...this.props}
        ref={this.page}
      >
        {this.state.erro && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />}

        {!this.state.erro && <>
          {this.state.datas.length > 0
            ? this.renderDados()
            : this.renderVazio()}
        </>}
      </MasterPage>
    );
  }
}
